import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { environment as ENV } from '@environments/environment';
import { CustomHttpTranslateLoader } from './custom-translate-loader.util';

const url = `${ENV.localeUrl}configJson.json`;
const fallback = '/assets/i18n/devConfigJson.json';

export function createTranslateLoader(http: HttpClient): CustomHttpTranslateLoader {
  return new CustomHttpTranslateLoader(http, url, fallback);
}

export function setTranslate(translate: TranslateService): () => Promise<any> {
  return (): Promise<any> => {
    const i18nFile = "configJson";
    translate.setDefaultLang(i18nFile);
    translate.use(i18nFile);
    return Promise.resolve({});
  };
}
